import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Landing } from "@/pages/Landing";
import { MusicShelf } from "@/games/music/MusicShelf";

// Each game lazy-loads on its first visit, keeping the initial bundle small.
const PlayLatinRootGarden = lazy(() =>
  import("@/pages/PlayLatinRootGarden").then((m) => ({ default: m.PlayLatinRootGarden })),
);
const PlayStoryStones = lazy(() =>
  import("@/pages/PlayStoryStones").then((m) => ({ default: m.PlayStoryStones })),
);
const PlayDeclineThis = lazy(() =>
  import("@/pages/PlayDeclineThis").then((m) => ({ default: m.PlayDeclineThis })),
);
const PlayPatternParade = lazy(() =>
  import("@/pages/PlayPatternParade").then((m) => ({ default: m.PlayPatternParade })),
);
const PlaySequenceSongs = lazy(() =>
  import("@/pages/PlaySequenceSongs").then((m) => ({ default: m.PlaySequenceSongs })),
);
const PlayAnimalTracks = lazy(() =>
  import("@/pages/PlayAnimalTracks").then((m) => ({ default: m.PlayAnimalTracks })),
);
const PlayBirdBySong = lazy(() =>
  import("@/pages/PlayBirdBySong").then((m) => ({ default: m.PlayBirdBySong })),
);
const PlayLiturgicalColors = lazy(() =>
  import("@/pages/PlayLiturgicalColors").then((m) => ({ default: m.PlayLiturgicalColors })),
);
const PlaySacramentMatch = lazy(() =>
  import("@/pages/PlaySacramentMatch").then((m) => ({ default: m.PlaySacramentMatch })),
);
const PlayCathedralParts = lazy(() =>
  import("@/pages/PlayCathedralParts").then((m) => ({ default: m.PlayCathedralParts })),
);
const PlayHolyLandCities = lazy(() =>
  import("@/pages/PlayHolyLandCities").then((m) => ({ default: m.PlayHolyLandCities })),
);
const PlayCloudReading = lazy(() =>
  import("@/pages/PlayCloudReading").then((m) => ({ default: m.PlayCloudReading })),
);
const PlayTreeByLeaf = lazy(() =>
  import("@/pages/PlayTreeByLeaf").then((m) => ({ default: m.PlayTreeByLeaf })),
);
const PlayApostleFind = lazy(() =>
  import("@/pages/PlayApostleFind").then((m) => ({ default: m.PlayApostleFind })),
);
const PlaySaintSymbols = lazy(() =>
  import("@/pages/PlaySaintSymbols").then((m) => ({ default: m.PlaySaintSymbols })),
);
const PlayHebrewNames = lazy(() =>
  import("@/pages/PlayHebrewNames").then((m) => ({ default: m.PlayHebrewNames })),
);
const PlayGreekRoots = lazy(() =>
  import("@/pages/PlayGreekRoots").then((m) => ({ default: m.PlayGreekRoots })),
);
const PlayConstellationQuest = lazy(() =>
  import("@/pages/PlayConstellationQuest").then((m) => ({
    default: m.PlayConstellationQuest,
  })),
);
const PlayVirtueGarden = lazy(() =>
  import("@/pages/PlayVirtueGarden").then((m) => ({ default: m.PlayVirtueGarden })),
);
const PlaySaintPairs = lazy(() =>
  import("@/pages/PlaySaintPairs").then((m) => ({ default: m.PlaySaintPairs })),
);
const PlayHymnPairs = lazy(() =>
  import("@/pages/PlayHymnPairs").then((m) => ({ default: m.PlayHymnPairs })),
);
const PlayStarPairs = lazy(() =>
  import("@/pages/PlayStarPairs").then((m) => ({ default: m.PlayStarPairs })),
);
const PlayBibleOrder = lazy(() =>
  import("@/pages/PlayBibleOrder").then((m) => ({ default: m.PlayBibleOrder })),
);
const PlayLiturgyOrder = lazy(() =>
  import("@/pages/PlayLiturgyOrder").then((m) => ({ default: m.PlayLiturgyOrder })),
);
const PlayCreedOrder = lazy(() =>
  import("@/pages/PlayCreedOrder").then((m) => ({ default: m.PlayCreedOrder })),
);
const PlayRomanNumerals = lazy(() =>
  import("@/pages/PlayRomanNumerals").then((m) => ({ default: m.PlayRomanNumerals })),
);
const PlayLatinVerbs = lazy(() =>
  import("@/pages/PlayLatinVerbs").then((m) => ({ default: m.PlayLatinVerbs })),
);
const PlayBodyLatin = lazy(() =>
  import("@/pages/PlayBodyLatin").then((m) => ({ default: m.PlayBodyLatin })),
);
const PlayTenCommandments = lazy(() =>
  import("@/pages/PlayTenCommandments").then((m) => ({ default: m.PlayTenCommandments })),
);
const PlayBeatitudesOrder = lazy(() =>
  import("@/pages/PlayBeatitudesOrder").then((m) => ({ default: m.PlayBeatitudesOrder })),
);
const PlayGiftsOfSpirit = lazy(() =>
  import("@/pages/PlayGiftsOfSpirit").then((m) => ({ default: m.PlayGiftsOfSpirit })),
);
const PlayFruitsOfSpirit = lazy(() =>
  import("@/pages/PlayFruitsOfSpirit").then((m) => ({ default: m.PlayFruitsOfSpirit })),
);
const PlayQuest = lazy(() =>
  import("@/pages/PlayQuest").then((m) => ({ default: m.PlayQuest })),
);
const ParentDashboard = lazy(() =>
  import("@/pages/ParentDashboard").then((m) => ({ default: m.ParentDashboard })),
);

function GameLoading() {
  return (
    <div className="above-paper container max-w-3xl py-20 text-center">
      <p className="text-sm italic text-ink-muted">Setting up the game…</p>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Suspense fallback={<GameLoading />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/play/latin-root-garden" element={<PlayLatinRootGarden />} />
          <Route path="/play/story-stones" element={<PlayStoryStones />} />
          <Route path="/play/decline-this" element={<PlayDeclineThis />} />
          <Route path="/play/pattern-parade" element={<PlayPatternParade />} />
          <Route path="/play/sequence-songs" element={<PlaySequenceSongs />} />
          <Route path="/play/constellation-quest" element={<PlayConstellationQuest />} />
          <Route path="/play/virtue-garden" element={<PlayVirtueGarden />} />
          <Route path="/play/greek-roots" element={<PlayGreekRoots />} />
          <Route path="/play/hebrew-names" element={<PlayHebrewNames />} />
          <Route path="/play/saint-symbols" element={<PlaySaintSymbols />} />
          <Route path="/play/apostle-find" element={<PlayApostleFind />} />
          <Route path="/play/tree-by-leaf" element={<PlayTreeByLeaf />} />
          <Route path="/play/cloud-reading" element={<PlayCloudReading />} />
          <Route path="/play/holy-land-cities" element={<PlayHolyLandCities />} />
          <Route path="/play/cathedral-parts" element={<PlayCathedralParts />} />
          <Route path="/play/sacrament-match" element={<PlaySacramentMatch />} />
          <Route path="/play/liturgical-colors" element={<PlayLiturgicalColors />} />
          <Route path="/play/bird-by-song" element={<PlayBirdBySong />} />
          <Route path="/play/animal-tracks" element={<PlayAnimalTracks />} />
          <Route path="/play/saint-pairs" element={<PlaySaintPairs />} />
          <Route path="/play/hymn-pairs" element={<PlayHymnPairs />} />
          <Route path="/play/star-pairs" element={<PlayStarPairs />} />
          <Route path="/play/bible-order" element={<PlayBibleOrder />} />
          <Route path="/play/liturgy-order" element={<PlayLiturgyOrder />} />
          <Route path="/play/creed-order" element={<PlayCreedOrder />} />
          <Route path="/play/roman-numerals" element={<PlayRomanNumerals />} />
          <Route path="/play/latin-verbs" element={<PlayLatinVerbs />} />
          <Route path="/play/body-latin" element={<PlayBodyLatin />} />
          <Route path="/play/ten-commandments" element={<PlayTenCommandments />} />
          <Route path="/play/beatitudes-order" element={<PlayBeatitudesOrder />} />
          <Route path="/play/gifts-of-spirit" element={<PlayGiftsOfSpirit />} />
          <Route path="/play/fruits-of-spirit" element={<PlayFruitsOfSpirit />} />
          <Route path="/quest" element={<PlayQuest />} />
          <Route path="/parent" element={<ParentDashboard />} />
        </Routes>
      </Suspense>
      <MusicShelf />
    </>
  );
}
